module.exports = __webpack_public_path__ + "static/img/ph.12f36eed.svg";